/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/KubernetesEndpoint/Actions/AzureSubscriptionAuthActionCreator" />
import { IVssPageContext } from "VSS/Platform/Context";
import { ActionsHubManager } from "DistributedTask/Flux/ActionsHubManager";
import { ActionCreatorBase } from "DistributedTask/Flux/Actions";
import { IAzureResourcesService } from "DistributedTask/Common/AzureResourcesService/AzureResourcesService";
import { IAzureRequestResult, IKubernetesCluster } from "DistributedTask/Common/AzureResourcesService/AzureResourceContracts";
import { AzureSubscription, AzureSubscriptionQueryResult } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { AzureSubscriptionAuthActions } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/KubernetesEndpoint/Actions/AzureSubscriptionAuthActions";
import { AzureSubscriptionAuthKeys } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/KubernetesEndpoint/KubernetesEndpointConstants";

export class AzureSubscriptionAuthActionCreator extends ActionCreatorBase {
    constructor(context: IVssPageContext) {
        super();
        this._azureEndpointService = context.getService<IAzureResourcesService>("IAzureResourcesService");
    }

    public initialize(instanceId?: string): void {
        this._actions = ActionsHubManager.GetActionsHub<AzureSubscriptionAuthActions>(AzureSubscriptionAuthActions, instanceId);
    }

    public static getKey(): string {
        return AzureSubscriptionAuthKeys.ActionCreatorKey;
    }

    public getAccessToken(azureSubscriptionTenantId: string): void {
        this._azureEndpointService.getAccessToken(azureSubscriptionTenantId).then((accessToken: string) => {
            this._actions.setAccessToken.invoke(accessToken);
        }, (error: any) => {
            this._actions.updateErrorMessage.invoke(error.message);
        });
    }

    public getAccessTokenAsync(azureSubscriptionTenantId: string): Promise<string> {
        return this._azureEndpointService.getAccessToken(azureSubscriptionTenantId);
    }

    public getAksClusters(
        azureSubscription: AzureSubscription,
        accessToken: string = "",
        callbackRequired: boolean = false,
        callbackParameters: { [key: string]: string } = {},
        resetClustersList: boolean = true
    ) {
        this._actions.fetchingMoreClusters.invoke(true);
        if (resetClustersList) {
            this._actions.resetAksClusterList.invoke();
        }

        this._azureEndpointService.getAzureKubernetesClusters(azureSubscription, accessToken, callbackRequired, callbackParameters)
            .then((result: IAzureRequestResult) => {
                if (!!result.data) {
                    this._actions.updateAksClusterList.invoke(result.data as IKubernetesCluster[]);
                }

                this._actions.fetchingMoreClusters.invoke(result.callbackRequired);

                if (result.callbackRequired) {
                    this.getAksClusters(azureSubscription, accessToken, result.callbackRequired, result.callbackParameters, false);
                }
            }, (error: any) => {
                this._actions.fetchingMoreClusters.invoke(false);
                this._actions.updateErrorMessage.invoke(error.message);
            });
    }

    public getKubernetesClusterNamespaces(
        azureSubscription: AzureSubscription,
        clusterId: string,
        clusterFqdn: string,
        accessToken: string = "",
        callbackRequired: boolean = false,
        callbackParameters: { [key: string]: string } = {},
        resetNamespacesList: boolean = true
    ) {
        this._actions.fetchingMoreNamespaces.invoke(true);
        if (resetNamespacesList) {
            this._actions.resetAksClusterNamespaceList.invoke();
        }

        this._azureEndpointService.getAzureKubernetesNamespaces(azureSubscription, accessToken, clusterId, clusterFqdn, callbackRequired, callbackParameters)
            .then((result: IAzureRequestResult) => {
                if (!!result.data) {
                    this._actions.updateAksClusterNamespaceList.invoke(result.data as string[]);
                }

                this._actions.fetchingMoreNamespaces.invoke(result.callbackRequired);

                if (result.callbackRequired) {
                    this.getKubernetesClusterNamespaces(azureSubscription, accessToken, clusterId, clusterFqdn, result.callbackRequired, result.callbackParameters, false);
                }
            }, (error: any) => {
                this._actions.fetchingMoreNamespaces.invoke(false);
                this._actions.updateErrorMessage.invoke(error.message);
            });
    }

    private _azureEndpointService: IAzureResourcesService;
    private _actions: AzureSubscriptionAuthActions;
}